import { getContentfulClient } from "..";
import { useAsync } from "react-use";
import { EntryCollection } from "contentful";
import { useEffect } from "react";

type ChatCidMapping = {
  utmContent: string;
  chatMessage: string;
};
export const defaultEntries: EntryCollection<ChatCidMapping> = {
  total: 0,
  skip: 0,
  limit: 0,
  items: [],
  toPlainObject: () => ({}),
  stringifySafe: () => "",
};

const formatMessage = (
  entries: EntryCollection<ChatCidMapping> | undefined = defaultEntries,
) => entries?.items?.[0]?.fields;

export const useChatMessage = (
  utmContent: string | null = "",
): ChatCidMapping => {
  const client = getContentfulClient();
  const query = {
    content_type: "chatCidPrompt",
    "fields.utmContent[in]": `${utmContent ?? ""}`,
  };

  //eslint-disable-next-line
  const { value, error } = useAsync(async () => {
    if (client) {
      // eslint-disable-next-line
      return (await client.getEntries(
        query,
      )) as EntryCollection<ChatCidMapping>;
    }
    return;
  }, []);

  useEffect(() => {
    if (error) {
      // eslint-disable-next-line
      console.error("Digital Secure Contentful fetch error", error);
    }
  }, [error]);

  return formatMessage(value as EntryCollection<ChatCidMapping>);
};
